module.exports = __webpack_public_path__ + "img/payment-maestro.bc47ed5d.svg";